var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.39583 18L6 17.4375L7.22917 14.4792C5.71528 14.3264 4.46528 13.6771 3.47917 12.5313C2.49306 11.3854 2 10.0417 2 8.5V5C2 4.16667 2.29167 3.45833 2.875 2.875C3.45833 2.29167 4.16667 2 5 2C5.22667 2 5.44306 2.02778 5.64917 2.08333C5.85528 2.13889 6.0625 2.20833 6.27083 2.29167L11.6042 4.39583L8 5.83333V6.8125L17 12L18 16H16.5L15.5 14.5H11.5V18H10V14.5H8.83333L7.39583 18ZM8 13H15.7292L14 12H8.25C7.41667 12 6.70833 11.7083 6.125 11.125C5.54167 10.5417 5.25 9.83333 5.25 9H6.75C6.75 9.4125 6.89687 9.76563 7.19062 10.0594C7.48437 10.3531 7.8375 10.5 8.25 10.5H11.3958L6.5 7.6875V5C6.5 4.5875 6.35271 4.23438 6.05813 3.94063C5.76354 3.64688 5.40937 3.5 4.99562 3.5C4.58187 3.5 4.22917 3.64688 3.9375 3.94063C3.64583 4.23438 3.5 4.5875 3.5 5V8.5C3.5 9.75 3.9375 10.8125 4.8125 11.6875C5.6875 12.5625 6.75 13 8 13ZM4.46875 5.53563C4.32292 5.39271 4.25 5.21563 4.25 5.00438C4.25 4.79313 4.32146 4.61458 4.46437 4.46875C4.60729 4.32292 4.78437 4.25 4.99562 4.25C5.20687 4.25 5.38542 4.32146 5.53125 4.46437C5.67708 4.60729 5.75 4.78437 5.75 4.99562C5.75 5.20687 5.67854 5.38542 5.53562 5.53125C5.39271 5.67708 5.21563 5.75 5.00437 5.75C4.79312 5.75 4.61458 5.67854 4.46875 5.53563Z",
    fill: "#094A58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile14);
export default __webpack_public_path__ + "static/media/profile-14.9fa2f18c47cb974c9adeca22f4693c9b.svg";
export { ForwardRef as ReactComponent };